import { Accordion, Text, Box } from '@nimbus-ds/components';
import { useTranslationCatalog } from 'domains/Catalog/hooks';
import { useGetTaxRulesQuery } from 'domains/Invoices/invoicesApi';
import TaxRulesError from './TaxRulesError';
import TaxRulesTable from './TaxRulesTable';

interface TaxRulesAccordionBodyProps {
  variantId: string;
}

function TaxRulesAccordionBody({
  variantId,
}: Readonly<TaxRulesAccordionBodyProps>) {
  const t = useTranslationCatalog('products.detail.invoiceSettings');

  const {
    data,
    isLoading: isLoadingTaxRules,
    isError,
    refetch,
  } = useGetTaxRulesQuery({ variantId });

  const hasTaxRules = (data?.length ?? 0) > 0;

  return (
    <Accordion.Body
      borderBottom="base"
      borderTop={hasTaxRules ? 'none' : 'base'}
    >
      <Box
        display="flex"
        justifyContent={hasTaxRules ? 'center' : 'flex-start'}
        alignItems="center"
        width="100%"
        height="100%"
        marginTop="4"
      >
        {isLoadingTaxRules && <TaxRulesTable.Skeleton />}
        {!isLoadingTaxRules && hasTaxRules && (
          <TaxRulesTable taxRules={data ?? []} />
        )}
        {!isLoadingTaxRules && isError && (
          <TaxRulesError onRetryError={refetch} />
        )}
        {!isLoadingTaxRules && !hasTaxRules && !isError && (
          <Box>
            <Text>{t('noTaxRules')}</Text>
          </Box>
        )}
      </Box>
    </Accordion.Body>
  );
}

export default TaxRulesAccordionBody;
